<template>
    <v-row no-gutters>
        <template>
            <div class="text-center">
                <v-dialog v-model="IsLoadingExport" persistent width="300">
                    <v-card color="primary" dark>
                        <v-card-text class="pt-2">
                            Sedang mengambil data..
                            <v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <template>
            <div class="p-3">
                <v-card class="mb-3" style="background-color: #f3f6f9;" elevation="0">
                    <v-container>
                        <div class="text-caption pb-1 indigo--text text--darken-4 font-weight-bold">
                            Filter
                        </div>
                        <v-row>
                            <v-col cols="12" md="6">
                                <label class="text-caption indigo--text text--darken-4">Berdasarkan angkatan</label>
                                <v-select small-chips dense class="pb-0" :items="selectOptions.angkatan"
                                    item-text="nama_angkatan" item-value="kode_angkatan" v-model="angkatan"
                                    label="Berdasarkan angkatan" @change="onChangeAngkatan($event)" solo></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="text-caption indigo--text text--darken-4">Berdasarkan status</label>
                                <v-select small-chips dense class="pb-0" :items="selectOptions.status" v-model="status"
                                    item-text="nama_status" item-value="id" label="Berdasarkan status"
                                    @change="onChangeStatus($event)" solo></v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <v-card elevation="1">
                    <v-card-title>
                        <v-row>
                            <v-col md="4" sm="12">
                                <v-text-field v-model="search" @keyup="onKeyup($event)" append-icon="mdi-magnify"
                                    label="Cari" single-line hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="users" item-key="no_induk" :search="search"
                        :loading="isLoading" loading-text="Mengambil data... Mohon tunggu" :server-items-length="count"
                        @pagination="onChangePagination($event)">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Rekapitulasi kerja praktik</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-btn outlined @click="toPDF()" color="primary" dark class="mb-2 mr-2">
                                    PDF
                                </v-btn>
                                <v-btn outlined @click="toCSV('csv')" color="primary" dark class="mb-2 mr-2">
                                    CSV
                                </v-btn>
                                <v-btn outlined @click="toCSV('xlsx')" color="primary" dark class="mb-2 mr-2">
                                    XLSX
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                v-if="item.kps.length !== 0 && ($isFTSP ? item.kps[0].level_aproval_sekarang >= 10 : item.berita_acara) && !item.kps[0].tanggal_realisasi_selesai_kp"
                                color="dark" @click="onSetDateClick(item.kps[0].id)">
                                mdi-calendar-check
                            </v-icon>
                            <a :href="urlCetakSuratPengantar(item)">
                                <v-icon v-if="item.kps.length !== 0 && item.kps[0].level_aproval_sekarang > 3" color="dark">
                                    mdi-file-send
                                </v-icon>
                            </a>
                            <v-icon v-if="item.kps.length !== 0" color="dark" class="mr-2"
                                @click="onDetailClick(item.kps[0].id)">
                                mdi-eye
                            </v-icon>
                            <v-icon v-if="$isFTSP && item.kps.length !== 0" color="dark" class="mr-2"
                                @click="onEditClick(item)">
                                mdi-pencil
                            </v-icon>
                            <!-- <a :href="onExportSuratPembimbing(item)">
                            <v-icon v-if="item.kps.length !== 0 && item.kps[0].level_aproval_sekarang > 6" color="dark">
                                mdi-file-account
                            </v-icon>
                        </a> -->
                        </template>
                        <template v-slot:no-data>
                            <br>
                            Belum ada data<br>
                            <v-btn class="m-4" color="gray" @click="initialize">
                                Mulai ulang
                            </v-btn>
                        </template>

                    </v-data-table>
                </v-card>
            </div>
        </template>
        <template>
            <v-dialog v-model="dialogEdit" max-width="600px" persistent>
                <v-card>
                    <v-card-title class="indigo darken-4 white--text">Edit Data KP</v-card-title>
                    <v-card-text class="pt-4">
                        <v-text-field
                            v-model="editForm.perusahaan_tujuan"
                            label="Perusahaan tujuan"
                            outlined
                            dense
                        ></v-text-field>
                        <v-textarea
                            v-model="editForm.alamat_perusahaan"
                            label="Alamat perusahaan"
                            outlined
                            dense
                            rows="3"
                        ></v-textarea>
                        <v-select
                            v-if="editForm.hasPembimbing"
                            v-model="editForm.pembimbing_id"
                            :items="dosenOptions"
                            item-text="name"
                            item-value="id"
                            label="Dosen pembimbing"
                            outlined
                            dense
                            clearable
                            :loading="isLoadingDosen"
                        ></v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEdit = false">Batal</v-btn>
                        <v-btn color="indigo darken-4" dark :loading="isLoadingSave" @click="onSaveEdit">Simpan</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-row>
</template>
<script>
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

export default {
    data: () => ({
        selectOptions: {
            status: [],
            angkatan: []
        },
        limit: 10,
        offset: 0,
        count: 10,
        name: '',
        angkatan: '',
        role_id: [],
        isLoading: false,
        IsLoadingExport: false,
        status: '',
        kd_status: '',
        users: [],
        search: '',
        dialogImport: false,
        dialog: false,
        dialogDelete: false,
        dialogEdit: false,
        isLoadingDosen: false,
        isLoadingSave: false,
        dosenOptions: [],
        editForm: {
            kpId: null,
            perusahaan_tujuan: '',
            alamat_perusahaan: '',
            pembimbing_id: null,
            hasPembimbing: false,
        },
        headers: [
            {
                text: 'Nama',
                align: 'start',
                value: 'name',
            },
            {
                text: 'No Induk',
                value: 'no_induk',
            },
            { text: 'Tanggal daftar', value: 'created_at' },
            { text: 'Perusahaan', value: 'perusahaan' },
            { text: 'Status', value: 'status' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
    }),
    created() {
        console.log(localStorage.getItem("isAuth", true));
        this.getStatusData();
        this.angkatan = '';
        this.kd_status = '';
        for (let index = 0; index < 20; index++) {
            this.selectOptions.angkatan.push({
                nama_angkatan: 13 + index,
                kode_angkatan: 13 + index,
            })
        }
        this.selectOptions.angkatan.unshift({
            nama_angkatan: 'Semua angkatan',
            kode_angkatan: '',
        })
    },
    methods: {
        errorToast() {
            this.$emit("toast", "error", 'Maaf, fitur ini belum tersedia');
            this.dialogImport = false;
        },
        onChangeStatus(event) {
            this.kd_status = event;
            this.getData();
        },
        onChangeAngkatan(event) {
            this.angkatan = event;
            this.getData();
        },
        getStatusData() {
            this.isLoading = true;
            this.axios.get("/api/master/status").then((res) => {
                let statusFinal = [1, 4, 7, 10, 11];
                this.selectOptions.status = res.data.data.filter(val => {
                    if (statusFinal.includes(val.id)) { return val };
                });
                // this.selectOptions.status = res.data.data;

                this.selectOptions.status.unshift({
                    nama_status: 'Memiliki KP',
                    id: 'kp',
                })
                this.selectOptions.status.unshift({
                    nama_status: 'Semua status',
                    id: '',
                })
                this.selectOptions.status.push({
                    nama_status: 'Belum set tanggal selesai',
                    id: 'set_tanggal_selesai'
                }, {
                    nama_status: 'Tidak memiliki KP',
                    id: -1,
                })
            }).finally(() => this.isLoading = false);
        },
        getData() {
            this.isLoading = true;
            const params = {
                status: this.kd_status,
                angkatan: this.angkatan,
                limit: this.limit,
                offset: this.offset,
                keyword: this.search
            };
            this.axios.get("/api/rekap/mahasiswa", { params: params }).then((res) => {
                this.count = res.data.count;
                this.users = res.data.data.map(val => {
                    if (val.kps.length !== 0) {
                        val.created_at = this.$dates.dateNoDayNoTime(val.kps[0].created_at);
                        val.perusahaan = val.kps[0].perusahaan_tujuan;
                        if (val.kps[0].riwayats.length !== 0) {
                            val.status = val.kps[0].riwayats[[val.kps[0].riwayats.length - 1]].status;
                        } else {
                            val.status = 'Belum mendaftar';
                        }
                        if (val.kps[0].dokumens.length > 4) {
                            val.berita_acara = val.kps[0].dokumens.find(x =>
                                x.jenis_dokumen_id == 8)
                        }
                    } else {
                        val.created_at = 'Belum mendaftar';
                        val.perusahaan = 'Belum mendaftar';
                        val.status = 'Belum mendaftar';

                    }
                    return val;
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        initialize() {
            this.getData();
        },
        generateRandomString(length) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            let result = ' ';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return '$' + result + '$';
        },
        setStatus(level) {
            switch (level) {
                case '1':
                    return 'Pendaftaran';
                    break;
                case '4':
                    return 'Unggah surat balasan';
                    break;
                case '7':
                    return 'Unggah laporan selesai';
                    break;
                case '10':
                    return 'Penilaian dosen';
                    break;
                case '11':
                    return 'Selesai';
                    break;

                default:
                    break;
            }
        },
        nilaiHuruf(kp) {
            return kp.nilai_huruf || this.$nilai.huruf(kp.nilai_angka);
        },
        komponenNilai(kp) {
            if (!kp || !kp.kp_penilaian) return [];
            return kp.kp_penilaian.kp_penialain_detail;
        },
        jumlahKomponenNilai(data) {
            return data.reduce((max, value) => Math.max(max, ...this.komponenNilai(value.kps[0]).map((x) => x.komponen_ke)), 0);
        },
        komponenNilaiColumns(jumlah) {
            let columns = [];
            for (let i = 1; i <= jumlah; i++) {
                columns.push('Komponen ' + i, 'Nilai komponen ' + i);
            }
            return columns;
        },
        komponenNilaiValues(kp, jumlah) {
            let komponen = this.komponenNilai(kp);
            let values = [];
            for (let i = 1; i <= jumlah; i++) {
                let item = komponen.find((x) => x.komponen_ke == i);
                values.push(item ? item.nama_komponen : '', item ? item.nilai : '');
            }
            return values;
        },
        onDetailClick(ids) {
            this.$router.push({ name: 'recap-student-read', query: { uuid: ids + '$' + this.generateRandomString(16) } });
        },
        onSetDateClick(ids) {
            this.$router.push({ name: 'set-finish-date', query: { uuid: ids + '$' + this.generateRandomString(16) } });
        },
        onEditClick(item) {
            const kp = item.kps[0];
            this.editForm.kpId = kp.id;
            this.editForm.perusahaan_tujuan = kp.perusahaan_tujuan;
            this.editForm.alamat_perusahaan = kp.alamat_perusahaan;
            this.editForm.hasPembimbing = kp.pembimbings && kp.pembimbings.length > 0;
            this.editForm.pembimbing_id = this.editForm.hasPembimbing ? kp.pembimbings[0].id : null;
            this.dialogEdit = true;
            if (this.dosenOptions.length === 0) {
                this.isLoadingDosen = true;
                this.axios.get('/api/kp/dosen-pembimbing').then(res => {
                    this.dosenOptions = res.data.data;
                }).finally(() => this.isLoadingDosen = false);
            }
        },
        onSaveEdit() {
            this.isLoadingSave = true;
            this.axios.put('/api/kp/' + this.editForm.kpId + '/officer', {
                perusahaan_tujuan: this.editForm.perusahaan_tujuan,
                alamat_perusahaan: this.editForm.alamat_perusahaan,
                pembimbing_id: this.editForm.pembimbing_id,
            }).then(() => {
                this.$emit('toast', 'success', 'Data berhasil diperbarui');
                this.dialogEdit = false;
                this.getData();
            }).catch(() => {
                this.$emit('toast', 'error', 'Gagal memperbarui data');
            }).finally(() => this.isLoadingSave = false);
        },
        onExportSuratPembimbing(user) {
            if (user.kps.length > 0)
                return this.$baseurl + '/api/cetak/' + user.kps[0].id + '/surat-bimbingan/' + user.id;
        },
        urlCetakSuratPengantar(user) {
            if (user.kps.length > 0)
                return this.$baseurl + '/api/cetak/' + user.kps[0].id + '/surat-pengantar';
        },
        onChangePagination(event) {
            this.limit = event.itemsPerPage;
            this.offset = event.itemsPerPage * (event.page - 1);
            this.getData();
        },
        onKeyup(event) {
            if (event.keyCode == 13) {
                console.log('keyup');
                this.getData();
            }
        },
        async toPDF() {

            let data = [];
            try {
                this.IsLoadingExport = true;
                const params = {
                    status: this.kd_status,
                    angkatan: this.angkatan,
                };
                data = await this.axios
                    .get("/api/rekap/mahasiswa", { params: params })
                    .then((res) => {
                        let users = res.data.data.map((val) => {
                            if (val.kps.length !== 0) {
                                val.created_at = this.$dates.dateNoDayNoTime(val.kps[0].created_at);
                                val.perusahaan = val.kps[0].perusahaan_tujuan;
                                if (val.kps[0].riwayats.length !== 0) {
                                    val.status =
                                        val.kps[0].riwayats[val.kps[0].riwayats.length - 1].status;
                                } else {
                                    val.status = 'Belum mendaftar';
                                }
                                if (val.kps[0].dokumens.length > 4) {
                                    val.berita_acara = val.kps[0].dokumens.find(
                                        (x) => x.jenis_dokumen_id == 8
                                    );
                                }
                            } else {
                                val.created_at = 'Belum mendaftar';
                                val.perusahaan = 'Belum mendaftar';
                                val.status = 'Belum mendaftar';
                            }
                            return val;
                        });
                        return users;
                    })
                this.IsLoadingExport = false;
            } catch (error) {
                this.IsLoadingExport = false;
                console.error("Error fetching data:", error);
            }

            if (data.length == 0) {
                this.$emit("toast", "warning", "Tidak ada data");
                return false;
            }

            const doc = new jsPDF({
                orientation: "landscape",
            });

            let columns = [
                'No',
                'Nama',
                'Email',
                'NIM',
                'No HP',
                'Perusahaan',
                'Alamat',
                'Tanggal daftar',
                'Realisasi Mulai KP',
                'Realisasi Selesai KP',
                'Pembimbing',
                'Lama KP',
                'Nilai',
                'Status',
            ]

            let jumlahKomponen = 0;
            if (this.$isFTSP) {
                jumlahKomponen = this.jumlahKomponenNilai(data);
                columns.splice(columns.indexOf('Nilai') + 1, 0, 'Nilai huruf', ...this.komponenNilaiColumns(jumlahKomponen));
            }

            let now = new Date();
            now = this.$dates.dateNoDayNoTime(now);

            let bodys = data.map((value, index) => {
                if (value.kps.length > 0) {
                    value.tanggal_daftar = this.$dates.dateNoDayNoTime(value.kps[0].created_at);
                    let endDate = new Date();
                    if (value.kps[0].tanggal_realisasi_selesai_kp) {
                        endDate = value.kps[0].tanggal_realisasi_selesai_kp;
                    }
                    value.lama_kp = this.$dates.dateDiff(value.kps[0].tanggal_realisasi_mulai_kp, endDate);
                    value.kps[0].tanggal_realisasi_mulai_kp = value.kps[0].tanggal_realisasi_mulai_kp ? this.$dates.dateNoDayNoTime(value.kps[0].tanggal_realisasi_mulai_kp) : null;
                    value.kps[0].tanggal_realisasi_selesai_kp = value.kps[0].tanggal_realisasi_selesai_kp ? this.$dates.dateNoDayNoTime(value.kps[0].tanggal_realisasi_selesai_kp) : null;
                    value.kps[0].level_aproval_sekarang = this.setStatus(value.kps[0].level_aproval_sekarang);
                    let pembimbing = '';
                    if (value.kps[0].pembimbings.length > 0) {
                        pembimbing = value.kps[0].pembimbings[0].name
                    }
                    let row = [
                        index + 1,
                        value.name,
                        value.email,
                        value.no_induk,
                        value.no_hp,
                        value.kps[0].perusahaan_tujuan,
                        value.kps[0].alamat_perusahaan,
                        value.tanggal_daftar,
                        value.kps[0].tanggal_realisasi_mulai_kp,
                        value.kps[0].tanggal_realisasi_selesai_kp,
                        pembimbing,
                        value.lama_kp,
                        value.kps[0].nilai_angka,
                    ];
                    if (this.$isFTSP) {
                        row.push(this.nilaiHuruf(value.kps[0]), ...this.komponenNilaiValues(value.kps[0], jumlahKomponen));
                    }
                    row.push(value.kps[0].level_aproval_sekarang);
                    return row;
                } else {
                    return [
                        index + 1,
                        value.name,
                        value.email,
                        value.no_induk,
                        value.no_hp,
                    ];
                }
            });

            let pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
            doc.setFontSize(8).setFont(undefined, 'bold');
            doc.text(`REKAPITULASI KERJA PRAKTIK`, pageWidth / 2, 10, { align: 'center' });
            doc.text(`${now.toUpperCase()}`, pageWidth / 2, 15, { align: 'center' });
            doc.text(`JURUSAN TEKNIK KIMIA`, pageWidth / 2, 20, { align: 'center' });
            doc.text(`UNIVERISTAS ISLAM INDONESIA`, pageWidth / 2, 25, { align: 'center' });

            doc.autoTable({
                startY: 35,
                tableLineWidth: 0.10,
                tableLineColor: [175, 175, 175],
                theme: "plain",
                headStyles: {
                    halign: 'center',
                    lineColor: [175, 175, 175],
                    lineWidth: 0.10,
                    cellPadding: 2,
                    fontSize: 6,
                },
                bodyStyles: {
                    lineColor: [175, 175, 175],
                    lineWidth: 0.1,
                    fontSize: 6,
                },

                columns: columns,
                body: bodys,
            })
            window.open(doc.output('bloburl'), '_blank');
        },
        async toCSV(event) {
            let data = [];
            try {
                this.IsLoadingExport = true;
                const params = {
                    status: this.kd_status,
                    angkatan: this.angkatan,
                };
                data = await this.axios
                    .get("/api/rekap/mahasiswa", { params: params })
                    .then((res) => {
                        let users = res.data.data.map((val) => {
                            if (val.kps.length !== 0) {
                                val.created_at = this.$dates.dateNoDayNoTime(val.kps[0].created_at);
                                val.perusahaan = val.kps[0].perusahaan_tujuan;
                                if (val.kps[0].riwayats.length !== 0) {
                                    val.status =
                                        val.kps[0].riwayats[val.kps[0].riwayats.length - 1].status;
                                } else {
                                    val.status = 'Belum mendaftar';
                                }
                                if (val.kps[0].dokumens.length > 4) {
                                    val.berita_acara = val.kps[0].dokumens.find(
                                        (x) => x.jenis_dokumen_id == 8
                                    );
                                }
                            } else {
                                val.created_at = 'Belum mendaftar';
                                val.perusahaan = 'Belum mendaftar';
                                val.status = 'Belum mendaftar';
                            }
                            return val;
                        });
                        return users;
                    })
                this.IsLoadingExport = false;

            } catch (error) {
                this.IsLoadingExport = false;
                console.error("Error fetching data:", error);
            }
            if (data.length == 0) {
                this.$emit("toast", "warning", "Tidak ada data");
                return false;
            }
            let jumlahKomponen = this.$isFTSP ? this.jumlahKomponenNilai(data) : 0;
            data = data.map((value, index) => {
                if (value.kps.length > 0) {
                    if (value.kps[0].pembimbings.length > 0) {
                        value.nama_pembimbing = value.kps[0].pembimbings[0].name;
                    }
                    value.tanggal_daftar = this.$dates.dateNoDayNoTime(value.kps[0].created_at);
                    let endDate = new Date();
                    if (value.kps[0].tanggal_realisasi_selesai_kp) {
                        endDate = value.kps[0].tanggal_realisasi_selesai_kp;
                    }
                    value.lama_kp = this.$dates.dateDiff(value.kps[0].tanggal_realisasi_mulai_kp, endDate);
                    value.kps[0].tanggal_rencana_mulai_kp = this.$dates.dateNoDayNoTime(value.kps[0].tanggal_rencana_mulai_kp);
                    value.kps[0].tanggal_realisasi_mulai_kp = value.kps[0].tanggal_realisasi_mulai_kp ? this.$dates.dateNoDayNoTime(value.kps[0].tanggal_realisasi_mulai_kp) : null;
                    value.kps[0].tanggal_rencana_selesai_kp = this.$dates.dateNoDayNoTime(value.kps[0].tanggal_rencana_selesai_kp);
                    value.kps[0].tanggal_realisasi_selesai_kp = value.kps[0].tanggal_realisasi_selesai_kp ? this.$dates.dateNoDayNoTime(value.kps[0].tanggal_realisasi_selesai_kp) : null;
                    value.kps[0].level_aproval_sekarang = this.setStatus(value.kps[0].level_aproval_sekarang)
                    let row = {
                        No: index + 1,
                        Nama: value.name,
                        Email: value.email,
                        NIM: value.no_induk,
                        No_HP: value.no_hp,
                        Nama_perusahaan: value.kps[0].perusahaan_tujuan,
                        Alamat_peerusahaan: value.kps[0].alamat_perusahaan,
                        Tanggal_daftar: value.tanggal_daftar,
                        Tanggal_rencana_mulai_kp: value.kps[0].tanggal_rencana_mulai_kp,
                        Tanggal_rencana_selesai_kp: value.kps[0].tanggal_rencana_selesai_kp,
                        Tanggal_realisasi_mulai_kp: value.kps[0].tanggal_realisasi_mulai_kp,
                        Tanggal_realisasi_selesai_kp: value.kps[0].tanggal_realisasi_selesai_kp,
                        Pembimbing: value.nama_pembimbing,
                        Lama_kp: value.lama_kp,
                        Nilai_angka: value.kps[0].nilai_angka,
                    };
                    if (this.$isFTSP) {
                        row.Nilai_huruf = this.nilaiHuruf(value.kps[0]);
                        let komponen = this.komponenNilaiValues(value.kps[0], jumlahKomponen);
                        for (let i = 0; i < jumlahKomponen; i++) {
                            row['Komponen_' + (i + 1)] = komponen[i * 2];
                            row['Nilai_komponen_' + (i + 1)] = komponen[i * 2 + 1];
                        }
                    }
                    row.Status = value.kps[0].level_aproval_sekarang;
                    return row;
                } else {
                    return {
                        No: index + 1,
                        Nama: value.name,
                        Email: value.email,
                        NIM: value.no_induk,
                        No_HP: value.no_hp,
                    };
                }
            });

            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws,);
            XLSX.writeFile(wb, 'Rekapitulasi ' + this.$dates.now() + '.' + event);
        }

    },

}
</script>